export default __webpack_public_path__ + "static/media/icon-logo.e65a093c.png";